.changeNotice {
  --ixf-readonly-list-change-notice-border-thickness: 2px;
  --ixf-readonly-list-change-notice-pill-offset: calc(
    20px + var(--ixf-readonly-list-change-notice-border-thickness)
  );

  border-radius: 0 var(--ixf-border-radius-2) var(--ixf-border-radius-2)
    var(--ixf-border-radius-2);
  border: var(--ixf-readonly-list-change-notice-border-thickness) solid
    var(--ixf-color-background);
  position: relative;
  padding: 0 var(--ixf-space-4);
  margin: var(--ixf-readonly-list-item-padding);
  margin-top: var(--ixf-readonly-list-change-notice-pill-offset);
  margin-left: 0;
  margin-right: 0;

  .pill {
    --ixf-pill-border-radius: var(--ixf-border-radius-1)
      var(--ixf-border-radius-1) 0 0;
    position: absolute;
    top: calc(-1 * var(--ixf-readonly-list-change-notice-pill-offset));
    left: calc(var(--ixf-readonly-list-change-notice-border-thickness) * -1);
  }

  &::after {
    content: "";
    position: absolute;
    top: calc(-1 * var(--ixf-readonly-list-change-notice-border-thickness));
    left: calc(-1 * var(--ixf-readonly-list-change-notice-border-thickness));
    width: calc(
      100% + (var(--ixf-readonly-list-change-notice-border-thickness) * 2)
    );
    height: calc(
      100% + (var(--ixf-readonly-list-change-notice-border-thickness) * 2)
    );
    border-radius: inherit;
    pointer-events: none;
    border: var(--ixf-readonly-list-change-notice-border-thickness) solid
      var(--ixf-color-tertiary-md);
    opacity: 0.2;
  }
}
